export default __webpack_public_path__ + "static/media/ico_twitter.a8d623cc.svg";